export const storage = {
    get: key => {
        const stored = localStorage.getItem(key)
        if (!stored) return null

        try {
            const item = JSON.parse(stored)
            const now = new Date()

            if (item?.expiry && now.getTime() > item?.expiry) {
                localStorage.removeItem(key)
                return null
            }

            return item?.value
        } catch (e) {
            return stored
        }
    },
    set: (key, value, days = 0) => {
        const now = new Date()
        const expiry = days && now.getTime() + days * 86400000

        const item = {
            value,
            expiry,
        }

        localStorage.setItem(key, JSON.stringify(item))
    },
    setAll: items => items.map(item => storage.set(item?.key, item?.value)),
    remove: key => localStorage.removeItem(key),
    wipe: () => localStorage.clear(),
    all: () => {
        const output = []
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i)
            const value = localStorage.getItem(key)
            output.push({ key, value })
        }
        return output
    },
}
